import { ProcessingTypeEnum } from '../enums/ProcessingType.enum'
import { ProcessingVariableEnum } from '../enums/ProcessingVariable.enum'
import { ProcessingResolutionEnum } from '../enums/ProcessingResolution.enum'

export class ForestInventoryStratum {
	constructor(
		readonly description: string,
		readonly processingDate: Date,
		readonly referenceDate: Date,
		readonly isSubsequent: boolean,
		readonly stumpHeight: number,
		readonly measurementId: string,
		readonly significanceLevel: number,
		readonly officialInventory: boolean,
		readonly newInventory: boolean,
		readonly type: ProcessingTypeEnum,
		readonly variables: ProcessingVariableEnum[],
		readonly resolution: ProcessingResolutionEnum,
		readonly images: string[],
		readonly aggregatingVariables: string,
		readonly products: any[],
		readonly volumeInventoryStratumId?: string,
		readonly id?: string,
		readonly status?: string,
		readonly stratumCode?: number,
		readonly commercialDiameter?: number,
	) {}
}
